// Create a new file: components/route/OrderProtectedRoute.js
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Loader from '../layouts/Loader';

export default function OrderProtectedRoute({ children }) {
    const { isAuthenticated, loading } = useSelector(state => state.authState);
    const { shippingInfo, items: cartItems } = useSelector(state => state.cartState);
    const isGuestCheckout = localStorage.getItem('isGuestCheckout') === 'true';
    const guestInfo = localStorage.getItem('guestInfo');

    if (loading) {
        return <Loader/>;
    }

    // Check if cart is empty
    if (!cartItems.length) {
        return <Navigate to="/cart" />;
    }

    // Check if shipping info exists
    if (!shippingInfo || !Object.keys(shippingInfo).length) {
        if (isAuthenticated) {
            return <Navigate to="/shipping" />;
        } else if (isGuestCheckout && guestInfo) {
            return <Navigate to="/guest-checkout" />;
        } else {
            return <Navigate to="/cart" />;
        }
    }

    // If we have shipping info and either authenticated or guest checkout, allow access
    if (isAuthenticated || (isGuestCheckout && guestInfo)) {
        return children;
    }

    // If none of the above conditions are met, redirect to cart
    return <Navigate to="/cart" />;
}